/**
 * Vue Filter - Guideline Link
 */

/**
 * Return link to guideline website.
 *
 * @param {number} val Number value
 * @param {boolean} usePref Use prefix
 */

const chapters = {
	a: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-c`,
	b: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-c`,
	c: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-c`,
	d: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-d`,
	e: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-e-k`,
	g: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-e-k`,
	h: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-e-k`,
	j: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-e-k`,
	k: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-e-k`,
	l: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	m: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	n: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	p: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	q: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	r: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	s: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	t: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
	x: `https://www.ussc.gov/guidelines/2024-guidelines-manual/annotated-2024-chapter-2-l-x`,
}

export default function guidelineLink(section) {
	if (!section) return `#`
	try {
		const [_, split] = section.split('')
		if (!split || !chapters[split]) return `#`

		return `${chapters[split]}#${section}`
	} catch (error) {
		console.error(error)
		return `#`
	}
}
